export default __webpack_public_path__ + "static/saas_banner-d793101147ff5ffa05b80f620ad2f504.webp";